export default "__VITE_ASSET__C8e8aIa7__"